__webpack_require__.p = "/best-quotes-live/";